import { Component, OnInit } from '@angular/core';
import { DocCategoriesCIF } from '../../viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { FormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-doc-category-vs',
  templateUrl: './doc-category-vs.component.html',
  styleUrls: ['./doc-category-vs.component.css']
})
export class DocCategoryVsComponent implements OnInit {
  public DocCategories: DocCategoriesCIF;
  public form: UntypedFormGroup;
  public myDocCat: string;

  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.DocCategories = new DocCategoriesCIF();

    this.store.select(getRegSearchState).subscribe(data => {
      this.DocCategories = data.docCategoriesVS[0];
      console.log(`data: ${JSON.stringify(data.docCategoriesVS[0])}`);
      console.log(`DocCats: ${JSON.stringify(this.DocCategories)}`);

      if (this.DocCategories.mortgages) {
        this.myDocCat = "mortgages";
      } else {
        this.myDocCat = "conveyances";
      }

    });
  }

  ngOnInit() {

    this.form = this.fb.group({
      'doccat': [this.myDocCat]
    });



    this.form.valueChanges.subscribe((value) => {
      if (this.form.valid) {
        console.log(`value: ${JSON.stringify(value)}`);
        this.myDocCat = value.doccat;
        if (this.myDocCat == "mortgages") {
          this.DocCategories.mortgages = true;
          this.DocCategories.conveyances = false;
        } else {
          this.DocCategories.mortgages = false;
          this.DocCategories.conveyances = true;

        }
        //console.log(`value.lastcorpName: ${value.lastcorpName}`);
        //this.DocCategories.conveyances = value.conveyances;
        //console.log(`conveyances: ${this.DocCategories.conveyances}`);
        //this.DocCategories.mortgages = value.mortgages;
        //console.log(`fName: ${this.utilityobj.fName}`);

      }
    });


  }

}
